import { useContext } from "react";
import TimelinePlayerContext from "../context/TimelinePlayerContext";

export default function useOnEnded(onEnded?: () => void) {
  const {
    timelineItemIndex,
    timelinePositions,
    setPlaying,
    setSeekToAbsolutePosition,
  } = useContext(TimelinePlayerContext);

  return () => {
    const isAtEndOfTimeline = timelineItemIndex === timelinePositions.size - 1;

    if (isAtEndOfTimeline) {
      setSeekToAbsolutePosition(0);
      setPlaying(false);
    }

    onEnded?.();
  };
}
